module.exports = __webpack_public_path__ + "static/media/powered_by_stripe.ea95435f.svg";